import { FC, lazy, Suspense } from 'react';
import { Fallback } from './Fallback';

const STVLandingAppLazy = lazy(() => import('landing/STVLandingApp'));

export const STVLandingApp: FC = () => {
  return (
    <Suspense fallback={<Fallback />}>
      <STVLandingAppLazy />
    </Suspense>
  );
};
